import { useEffect, useRef, useState } from "react";
import api from "../lib/api";

// Key by prescription AND source text: an old patient's translation must never
// appear after navigating to another prescription or switching languages quickly.
export function usePrintAdviceTranslation(rxId, lang, text) {
  const cache = useRef(new Map());
  const [result, setResult] = useState(null);
  const [attempt, setAttempt] = useState(0);
  const required = lang !== "en" && !!text;
  const key = JSON.stringify([rxId, lang, text]);
  useEffect(() => {
    if (!required) return;
    let active = true;
    const cached = cache.current.get(key);
    if (cached) {
      setResult({ key, text: cached });
      return;
    }
    setResult({ key, loading: true });
    api.post("/ai/translate-advice", { lang, text }, { timeout: 90000 })
      .then(({ data }) => {
        if (!active) return;
        if (!data.translated?.trim()) throw new Error("Translation unavailable");
        cache.current.set(key, data.translated);
        setResult({ key, text: data.translated });
      })
      .catch(() => {
        if (active) setResult({ key, error: "Advice translation is unavailable. The original advice is retained." });
      });
    return () => { active = false; };
  }, [key, required, lang, text, attempt]);

  const current = result?.key === key ? result : null;
  return {
    translated: required ? current?.text || "" : "",
    loading: required && (!current || !!current.loading),
    error: required ? current?.error || "" : "",
    retry: () => { setResult(null); setAttempt((n) => n + 1); },
  };
}